<template>
  <div>
    <div class="boxs">
      <PrimaryBox>
        <template slot="title">事件统计</template>
        <div class="content" style="background-color: rgba(46,107,158,0.2)">
          <div class="statisticTop">
            <div style="width: 100%;height: 100px;">
              <Type></Type>
            </div>
<!--            <div style="width: 100%;height: 10vh;">-->
<!--              <Process></Process>-->
<!--            </div>-->
          </div>
          <Divider style="margin-top: .1vh;width: 80%" dashed></Divider>
          <div class="statisticBottom">
            <StatisticsLine></StatisticsLine>
          </div>
        </div>
      </PrimaryBox>
    </div>
  </div>
</template>

<script>
import PrimaryBox from "@/views/Screen/components/PrimaryBox/PrimaryBox";
import Type from "./components/type/type";
// import Process from "./components/process/process";
import StatisticsLine from "./components/statisticsLine/statisticsLine";

export default {
  name: "RoadStatistics",
  components: {
    PrimaryBox,
    Type,
    // Process,
    StatisticsLine
  },
}
</script>

<style scoped lang="less">
@import "RoadStatistics";
</style>
